import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { router } from "./App.tsx";
import { RouterProvider } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import {
  OpenFeatureProvider,
  OpenFeature,
  InMemoryProvider,
} from "@openfeature/react-sdk";
import { ConfigCatWebProvider } from "@openfeature/config-cat-web-provider";

import "maplibre-gl/dist/maplibre-gl.css";
import "react-day-picker/dist/style.css";

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

Sentry.init({
  dsn: "https://3f1ad7ecee87659ddfed249b3aa8704f@o4510182985564160.ingest.de.sentry.io/4510182987333712",
  sendDefaultPii: true,
  enableLogs: true,
  enabled: import.meta.env.NODE_ENV === "production",
});

const isDev = import.meta.env.DEV;

if (isDev) {
  const inMemoryProvider = new InMemoryProvider({
    flight_plan_submission_enabled: {
      variants: {
        on: true,
        off: false,
      },
      defaultVariant: "on",
      disabled: false,
    },
    subscriptions_enabled: {
      variants: {
        on: true,
        off: false,
      },
      defaultVariant: "on",
      disabled: false,
    },
  });
  OpenFeature.setProvider(inMemoryProvider);
} else {
  const configCatProvider = ConfigCatWebProvider.create(
    import.meta.env.VITE_CONFIG_CAT_SDK_KEY,
  );
  OpenFeature.setProvider(configCatProvider);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OpenFeatureProvider>
      <RouterProvider router={router} />
    </OpenFeatureProvider>
  </StrictMode>
);
